import { Loggable } from '@johnlewispartnership/wtr-website-logger';
import config from 'config';
import { getApm } from 'shared/apm';

const toError = (arg: Loggable): Error => {
  if (arg instanceof Error) {
    return arg;
  }

  if (typeof arg === 'string') {
    return new Error(arg);
  }

  try {
    return new Error(JSON.stringify(arg));
  } catch {
    return new Error('Failed to serialise error object: ' + String(arg));
  }
};

const sendToApm = async (arg: Loggable) => {
  const apm = await getApm('error-only');

  if (!apm) {
    console.error('APM is not available on the window.', arg);
    return;
  }

  apm.captureError(toError(arg));
};

const createLogMethod = (consoleMethod: (arg: Loggable) => void, shouldSendToApm = false) => {
  const { clientSideLogging } = config;

  return (arg: Loggable) => {
    if (clientSideLogging) {
      consoleMethod(arg);
    }

    if (shouldSendToApm) {
      sendToApm(arg);
    }
  };
};

export const logger = {
  debug: createLogMethod(console.debug),
  info: createLogMethod(console.info),
  warn: createLogMethod(console.warn),
  error: createLogMethod(console.error, true),
  fatal: createLogMethod(console.error, true),
};
